export default {
    "feedback":{
        "text" : "",
        "title": "Sende Rückmeldung an den Sinequa-Admin",
        "content": {
          "text": "Inhalt",
          "title": "Vorschlag zum Hinzufügen neuer Inhalte oder zur Verbesserung vorhandener Inhalte"
        },
        "ui": {
          "text": "Benutzeroberfläche",
          "title": "Schlage Verbesserungen für die Benutzeroberfläche vor"
        },
        "lang": {
          "text": "Sprache",
          "title": "Schlage Verbesserungen für die Sprachverarbeitung vor wie neue Worte oder Synonyme, die zu den Wörterbüchern hinzugefügt werden sollen (dies hat direkte Auswirkungen auf die Relevanzberechnung der Suchmaschine)"
        },
        "other": {
          "text": "Andere",
          "title": "Reichen Sie einen Vorschlag für eine zusätzliche Funktion oder andere Verbesserungvorschläge ein"
        },
        "thankyou": "Vielen Dank für Ihre Rückmeldung!",
        "quality": {
          "label": "Qualität des Dokuments:"
        },
        "relevance": {
          "label": "Relevanz des Dokuments:"
        },
        "labels" : {
            "public": {
              "label": "Etiketten:"
            },
            "private": {
              "label": "Private Etiketten:"
            }
        }
    }
};
